module.exports = __webpack_public_path__ + "static/media/191EE156.62efbf2b.jpg";